import { render, staticRenderFns } from "./notAvailable.vue?vue&type=template&id=8c265456&"
import script from "./notAvailable.vue?vue&type=script&lang=js&"
export * from "./notAvailable.vue?vue&type=script&lang=js&"
import style0 from "./notAvailable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports